export class Compania{
  
		public idCompania:number;
		public Nombre:string;
		public ID_LOOKUP_TPN:number;
		public ID_LOOKUP_DAY:number;
		public SUBURB:string;

	
}


// WEBPACK FOOTER //
// ./src/app/models/compania.ts